import { ApiEndpoints } from '../../../utils/app-constants';
import { toCondensedDate, toShortDate } from '../../../utils/date-utils';
import { 
    DOCUMENT_EXTENSIONS,
    DOCUMENT_REQUEST_LOCATION, 
    IDocumentRequest 
} from '../../utilities/document-request';
import { API_METHODS } from '../../utilities/type-models';

export class AccountMateFinancialDocument implements IDocumentRequest {

    public filename : string = '';
    public fileExtension : DOCUMENT_EXTENSIONS = 'xlsx';
    public openInTab : boolean = false;
    public reportLocation : DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType : API_METHODS = 'GET';

    public url : string = '';

    constructor(startDate: Date, endDate: Date) {

        const startStr = toShortDate(startDate);
        const endStr = toShortDate(endDate);
        this.url = ApiEndpoints.ACCOUNTING_ACCOUNTMATE_REPORT.formattify(startStr, endStr);
        this.filename = `Financials_${ toCondensedDate(startDate) }_${ toCondensedDate(endDate) }`;

    }

}
